<template>
  <div class="sp_step">
    <el-form :model="stepThreeForm"
             ref="stepThreeForm"
             :rules="stepThreeRules">
      <el-form-item :label="$t('loginModule.newPassword')+'：'"
                    prop="newPassword">
        <el-input :type="newPassType"
                  size="medium"
                  v-model.trim="stepThreeForm.newPassword"
                  autocomplete="new-password">
          <svg-icon :icon-class="newPassType == 'password' ? 'hide' : 'view'"
                    slot="suffix"
                    @click.native="newPassView"></svg-icon>
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('loginModule.confirmPassword') +'：'"
                    prop="confirmPassword"
                    @submit.native.prevent>
        <el-input :type="confirmPassType"
                  size="medium"
                  v-model.trim="stepThreeForm.confirmPassword"
                  autocomplete="new-password">
          <svg-icon :icon-class="confirmPassType == 'password' ? 'hide' : 'view'"
                    slot="suffix"
                    @click.native="confirmPassView"></svg-icon>
        </el-input>
      </el-form-item>

      <el-form-item style="padding-top:12px;">
        <el-button type="primary"
                   size="medium"
                   style="width:100%;height:48px; font-size:16px;"
                   @click="confirm('stepThreeForm')">{{$t('loginModule.confirm')}}</el-button>
        <div class="sp_login_skip">
          <router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updatePassword } from '@/api/loginApi.js'
import { registerEncrypt } from "@/utils/encrypt.js"
export default {
  name: "stepThree",
  props: {
    forgotParamsthree: {
      type: Object,
      required: true,
      default: () => { },
    }
  },
  data () {
    var checkNewPassword = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error("Please input the password."))
      } else {
        if (Reg.test(value)) {
          if (this.stepThreeForm.confirmPassword) {
            if (this.stepThreeForm.newPassword === this.stepThreeForm.confirmPassword) {
              const _this = this
              _this.$refs.stepThreeForm.clearValidate('confirmPassword')
              return callback()
            } else {
              return callback("Those passwords didn't match. Try again.")
            }
          } else {
            return callback()
          }
        } else {
          return callback(new Error("Use 8 to 16 characters with a mix of letters, numbers & symbols."))
        }
      }
    }
    var checkConfirmPas = (rule, value, callback) => {
      const Reg = /^(?!.*\s)(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/
      if (!value) {
        return callback(new Error("Please confirm the password again."))
      } else {
        if(Reg.test(value)){
          if(this.stepThreeForm.confirmPassword){
            if (this.stepThreeForm.newPassword === this.stepThreeForm.confirmPassword){
              const _this = this
              _this.$refs.stepThreeForm.clearValidate('newPassword')
              return callback()
            }else{
              return callback("Those passwords didn't match. Try again.")
            }
          }else{
            return callback()
          }
        }else{
          return callback(new Error("Use 8 to 16 characters with a mix of letters, numbers & symbols."))
        }
      }
    }
    return {
      stepThreeForm: {
        newPassword: "",
        confirmPassword: '',
      },
      stepThreeRules: {
        newPassword: [
          { required: true, validator: checkNewPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: checkConfirmPas, trigger: 'blur' }
        ],
      },

      newPassType: 'password',
      confirmPassType: "password"
    }
  },

  methods: {
    //切换密码框密码显示隐藏
    newPassView () {
      this.newPassType = this.newPassType == 'password' ? 'text' : 'password';
    },
    confirmPassView () {
      this.confirmPassType = this.confirmPassType == 'password' ? 'text' : 'password';
    },

    confirm (stepThreeForm) {
      this.$refs[stepThreeForm].validate(valid => {
        if (valid) {
          let params = {
            password: registerEncrypt(JSON.parse(JSON.stringify(this.stepThreeForm.newPassword))),
            email: registerEncrypt(JSON.parse(JSON.stringify(this.forgotParamsthree.email))),
            // verificationCode: this.forgotParamsthree.verificationCode
          }
          updatePassword(params).then(res => {
            console.log(res);
            this.$message({
              type: 'success',
              message: 'Your password has been reset successfully, please log in again.'
            })
            this.$router.push({ path: '/login' })
          })
        }
      })
    }
  },
  mounted(){
    console.log(this.forgotParamsthree);
  }
}
</script>

<style>
</style>